/**
 * React Query configuration for messaging/conversations
 * Query keys factory pattern following Processes2 conventions
 */

export const MESSAGING_RQ_KEY = 'messaging';

export const messagingQueryKeys = {
  all: [MESSAGING_RQ_KEY] as const,

  // Channels
  channels: () => [...messagingQueryKeys.all, 'channels'] as const,
  channelsList: (filters: {
    type?: string;
    section?: string;
    limit?: number;
    offset?: number;
  }) => [...messagingQueryKeys.channels(), { filters }] as const,
  channelsSearch: (search: string, limit?: number, offset?: number) =>
    [
      ...messagingQueryKeys.channels(),
      'search',
      { search, limit, offset },
    ] as const,
  channel: (id: number) => [...messagingQueryKeys.all, 'channel', id] as const,

  // Messages
  messages: (channelId: number) =>
    [...messagingQueryKeys.all, 'messages', channelId] as const,
  messagesList: (
    channelId: number,
    filters: { beforeMessageId?: number; limit?: number }
  ) => [...messagingQueryKeys.messages(channelId), { filters }] as const,

  // Members
  members: (channelId: number) =>
    [...messagingQueryKeys.all, 'members', channelId] as const,
  eligibleUsers: (channelId: number, search?: string) =>
    [...messagingQueryKeys.members(channelId), 'eligible', { search }] as const,

  // Internal Users (for channel creation)
  internalUsers: (search?: string) =>
    [...messagingQueryKeys.all, 'internal-users', { search }] as const,
  eligibleUsersForCreation: (
    channelType: string,
    projectId?: number,
    search?: string
  ) =>
    [
      ...messagingQueryKeys.all,
      'eligible-users-for-creation',
      { channelType, projectId, search },
    ] as const,

  // Files
  files: (channelId: number) =>
    [...messagingQueryKeys.all, 'files', channelId] as const,

  // Unread counts
  unreadCounts: () => [...messagingQueryKeys.all, 'unread-counts'] as const,

  // User data
  myAccountsList: () =>
    [...messagingQueryKeys.all, 'my-accounts-list'] as const,
  projectSearch: (search?: string) =>
    [...messagingQueryKeys.all, 'project-search', { search }] as const,
};

// API base path
export const MESSAGING_API_BASE = '/api/messaging';

// List pagination defaults
export const DEFAULT_CHANNELS_LIMIT = 50;
export const DEFAULT_MESSAGES_LIMIT = 50;
export const DEFAULT_MEMBERS_LIMIT = 50;
